import styled from 'styled-components'

import { Text } from '../text'
import { LeftButtonBox } from './Header'
import type { HeaderContentProps } from './Header'

import { ReactComponent as Close } from '../../assets/ico/common/close/close_black.svg'

export function Modal({ title, rightItem, onDismiss }: HeaderContentProps) {
  return (
    <>
      <TitleBox>
        <LeftButtonBox onClick={onDismiss}>
          <Close />
        </LeftButtonBox>
        {title && (
          <Text size={20} weight={600}>
            {title}
          </Text>
        )}
      </TitleBox>
      {rightItem && <>{rightItem}</>}
    </>
  )
}

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
`
